<template>
    <Login v-if="loginStatus" @closed="loginStatus = false" @loginSuccess="nextPay" />
</template>
<script>
import { linkApp } from '../../utils'
import { ActionSheet, Button, Toast, Dialog } from 'vant'
import Login from './login.vue'
import { payGoods, getWxPayInfo } from '../../api'

export default {
    name: 'vipCoachV2Pay',
    components: {
        Login
    },
    data () {
        return {
            orderInfo: {},
            loginStatus: false
        }
    },
    computed: {
        wxUserInfo () {
            return this.$store.getters['vipCoach/wxUser']
        }
    },
    methods: {
        // 获取登录状态
        getIsLogin () {
            return !!(this.wxUserInfo.phone && this.wxUserInfo.token)
        },
        // 登录成功 继续走支付逻辑
        nextPay () {
            this.createOrder(this.orderInfo)
        },
        /**
         * 创建订单
         * @param {Object} data 商品信息
         */
        createOrder (data) {
            data.userMobile = this.wxUserInfo.phone
            data.virtuallyToken = this.wxUserInfo.token
            this.orderInfo = {
                ...data
            }
            // 获取登录状态
            if (this.getIsLogin()) {
                Toast.loading({ duration: 0, mask: false, forbidClick: true })
                payGoods(data).then(({ result, status, message, code }) => {
                    if (status && result) { // 请求成功 并且有订单编号
                        // 生成订单成功 获取微信支付配置
                        this.orderInfo.orderId = result
                        this.getWxPayConfig()
                    } else if (['40001', '40008'].includes(code)) {
                        Toast.clear()
                        Dialog.confirm({
                            title: '温馨提示',
                            message,
                            theme: 'round-button',
                            className: 'vip-coach-btn',
                            confirmButtonText: '前往APP使用'
                        }).then(() => {
                            linkApp()
                        })
                    } else {
                        Toast(message)
                    }
                })
            } else { // 没登录去登录
                this.loginStatus = true
            }
        },
        /**
         * 获取微信支付配置
         */
        getWxPayConfig () {
            // 获取openid
            const openId = this.wxUserInfo.openId
            // 获取对应参数
            const { goodsCode, orderId } = this.orderInfo
            getWxPayInfo({
                goodsCode,
                orderId,
                openid: openId
            }).then(({ result, status, message }) => {
                if (status) {
                    this.wxPay(result)
                } else {
                    Toast(message)
                }
            })
        },
        wxPay (data) {
            let self = this
            function onBridgeReady () {
                window.WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        appId: data.appId,
                        timeStamp: data.timeStamp,
                        nonceStr: data.nonceStr,
                        package: data.packageValue,
                        signType: data.signType,
                        paySign: data.paySign
                    },
                    function (res) {
                        if (res.err_msg === 'get_brand_wcpay_request:ok') {
                            Toast.loading({ duration: 3000, forbidClick: true, message: '支付成功\n正在跳转订单详情页' })
                            setTimeout(() => {
                                self.$router.push({
                                    name: 'vipCoachGoodsDetail',
                                    query:
                                    {
                                        orderId: self.orderInfo.orderId,
                                        goodsCode: self.orderInfo.goodsCode
                                    }
                                })
                            }, 3000)
                        } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                            Toast.fail('取消支付')
                        } else {
                            Toast.fail('支付失败')
                        }
                    })
            }
            if (typeof WeixinJSBridge === 'undefined') {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
                }
            } else {
                onBridgeReady()
            }
        }
    }
}
</script>
